import React from 'react'

import Layout from 'src/components/common/Layout'
import StatusTemplate from 'src/components/template/status'

export default (props) => {
  const titleText = (
    <>
      Lo sentimos, <br />
      este contenido no está disponible en tu país.
    </>
  )
  return (
    <Layout location={props.location} lang="es" market="spain" noFooter noIndex>
      <StatusTemplate title={titleText} />
    </Layout>
  )
}
